<template>
  <colgroup>
    <col
      v-for="(header, i) in headers"
      :key="i + 'column'"
      v-bind:style="{
        width: header.width + 'px'
      }"
    />
  </colgroup>
</template>

<script>
export default {
  name: "HeatmapColGroup",
  props: { headers: { type: Array } }
};
</script>
